import Vue from "vue";
import router from "@/router";
import Vuex from "vuex";
import { Ajax, baseURL } from "@/ajax";
import Cookies from "js-cookie";
import { debounce } from "riku-verycloud";
import { Toast } from "vant";
import myPopup from "../mypopup";
import { upsertLocalAccount } from "@/utils/localAccounts";
Vue.use(Vuex);

const storage = window.localStorage;
const localStorageKey = "vip";
const localStorage = storage.getItem(localStorageKey)
  ? JSON.parse(storage.getItem(localStorageKey))
  : {};

const state = {
  accessToken: Cookies.get("accessToken") || storage.getItem("accessToken"),
  refreshToken: Cookies.get("refreshToken") || storage.getItem("refreshToken"),
  appdeviceinfo: Cookies.get("appdeviceinfo"),
  isApp: storage.getItem("isApp") || false,
  uuid: storage.getItem("uuid"),
  userData: null,
  errorQueue: new Set(),
  differTime: 0,
  searchHistory: {},
  ...localStorage,
  buyInfo: storage.getItem("buyInfo"),
  uploadInfo: storage.getItem("uploadInfo"),
  isOne: 0,
  showfeng: null,
  channel: null,
  payShow: false,
  yunstr: "",
  groupShow: false,
  bgColor: false,
  firstOrder: false,
  signInShow: false,
  isSigned: false, //是否开启签到
  isIdentity: false, //是否实名
  isDisabledChannel: false, //渠道是否显示游戏库
  loginDevDetail: {}, //登录设备详情
  instanceId: [], //取消的授权设备id数组
  isWxApp: false,
};

// history fixed
if (!state.searchHistory || state.searchHistory instanceof Array) {
  state.searchHistory = {};
}

const getters = {
  ua() {
    const ua = navigator.userAgent;
    const isTablet = /(?:iPad|PlayBook)/.test(ua);
    const isAndroid = /(?:Android)/.test(ua);
    const isIphone = /(?:iPhone)/.test(ua) && !isTablet;
    const isPc = !isIphone && !isAndroid && !isTablet;
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // eslint-disable-next-line
    const isWechat =
      ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
    return {
      isTablet,
      isAndroid,
      isIphone,
      isPc,
      isWechat,
      isiOS,
    };
  },
  state(state) {
    return state;
  },
  userId() {
    return state.userData ? state.userData.id : null;
  },
  avatar() {
    return state.userData && state.userData.head_img;
  },
  isLogin() {
    return state.accessToken && true;
  },
  setCancellation() {
    return state.user_logoff_data;
  },
  user_logoff_data() {
    return state.user_logoff_data;
  },
  // 是否实名认证
  isIDVerify() {
    return state.userData && state.userData.identityFlag && true;
  },
  // 判断query中的userId是否是自己
  isSelf: (state) => (userId) => {
    return (
      getters.isLogin() &&
      (userId ? userId == (state.userData && state.userData.id) : true)
    );
  },
  isMobile: (state) => (v) => {
    return /^(13[\d]{9}$|^14[\d]{9}$|^15[\d]{9}$|^16[\d]{9}$|^17[\d]{9}$|^18[\d]{9}$|^19[\d]{9})$/.test(
      v
    );
  },
  isEmail: (state) => (v) => {
    // eslint-disable-next-line
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      v
    );
  },
  rules: (state) => {
    return {
      mobile: [
        { required: true, message: "请输入手机号码" },
        {
          validator: (rule, value, callback) => {
            let error;
            if (!store.getters.isMobile(value)) error = "手机号码格式不正确";
            callback(error);
          },
          trigger: "blur",
        },
      ],
      captcha: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "change",
        },
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
        },
        {
          min: 6,
          max: 20,
          message: "密码的长度在6～20之间",
        },
      ],
      confirmPassword: (compare) => {
        return [
          { required: true, message: "请再次输入密码" },
          {
            validator: (rule, value, callback) => {
              let error;
              if (value != compare) error = "两次密码不一致";
              callback(error);
            },
            trigger: "blur",
          },
        ];
      },
      confirmChange: (compare) => {
        return {
          validator: (rule, value, callback) => {
            let error;
            if (value == compare) error = "没有任何变化";
            callback(error);
          },
        };
      },
      confirmChange1: (compare) => {
        return {
          validator: (rule, value, callback) => {
            console.log(value);
            let error;
            if (value == compare) error = "没有任何变化";
            callback(error);
          },
        };
      },
      idNumber: [
        {
          required: true,
          message: "请填写身份证号",
        },
        {
          pattern:
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          message: "身份证格式不正确",
        },
      ],
      userName: [
        {
          required: true,
          message: "请输入账号",
        },
        {
          trigger: "blur",
        },
      ],
      bindPassword: [
        {
          required: true,
          message: "请输入密码",
        },
        {
          trigger: "blur",
        },
      ],
    };
  },
  getCaptcha:
    (state) =>
    ({ url, phone, action }) => {
      return () => {
        return new Promise((resolve, reject) => {
          Ajax(url, { phone, action }).then((rs) => {
            if (rs.status == 1) {
              Toast(rs.msg);
            } else {
              Toast(rs.msg);
            }
          });
        });
      };
    },
};

const mutations = {
  setIsWxApp(state, status) {
    state.isWxApp = status;
  },
  setUuid(state, status) {
    state.uuid = status;
  },
  setFirstOrder(state, status) {
    state.firstOrder = status;
  },
  setBgColor(state, status) {
    state.bgColor = status;
  },
  setLoginDevDetail(state, status) {
    state.loginDevDetail = status;
  },
  setGroup(state, status) {
    state.groupShow = status;
  },
  setYunstr(state, status) {
    state.yunstr = status;
  },
  payClick(state, status) {
    state.payShow = status;
  },
  setChannel(state, status) {
    state.channel = status;
  },
  setFeng(state, status) {
    state.showfeng = status;
  },
  setSignIn(state, status) {
    state.signInShow = status;
  },
  isSetSign(state, status) {
    state.isSigned = status;
  },
  setDisabledChannel(state, status) {
    state.isDisabledChannel = status;
  },
  isIdentityFlag(state, status) {
    state.isIdentity = status;
  },
  isOneLogin(state, status) {
    state.isOne = status;
  },
  watchApp(state, status) {
    state.isApp = status;
    storage.setItem("isApp", status);
  },
  setBuyInfo(state, obj) {
    state.buyInfo = obj;
    storage.setItem("buyInfo", obj);
  },
  setUploadInfo(state, obj) {
    state.uploadInfo = obj;
    storage.setItem("uploadInfo", obj);
  },
  state(state, obj) {
    Object.assign(state, obj);
  },
  setServiceTime(state, date) {
    let localTime = new Date();
    let serveTime = new Date(date);
    state.differTime = localTime.valueOf() - serveTime.valueOf();
  },
  addSearchHistory(state, [key, keyword]) {
    const maxlength = 5;
    let history = [...new Set([keyword, ...(state.searchHistory[key] || [])])];
    if (history.length > maxlength) {
      history = history.slice(0, maxlength);
    }
    state.searchHistory[key] = history;
  },
  deleteHistory(state, [key, keyword]) {
    const set = new Set(state.searchHistory[key]);
    set.delete(keyword);
    state.searchHistory[key] = [...set];
  },
  clearHistory(state, key) {
    state.searchHistory[key] = [];
  },
};

const actions = {
  setAppInfo: ({ commit }, { appdeviceinfo }) => {
    Cookies.set("appdeviceinfo", appdeviceinfo);
    commit("state", { appdeviceinfo });
  },
  setCookies: (
    { commit },
    { userId, id, accessToken, accessExpire, refreshToken, refreshExpire }
  ) => {
    const finalUserId = userId != null && userId !== "" ? userId : id;
    Cookies.set("accessToken", accessToken, {
      expires: (accessExpire - new Date().getTime() / 1000) / 86400,
    });
    Cookies.set("refreshToken", refreshToken, {
      expires: (refreshExpire - new Date().getTime() / 1000) / 86400,
    });
    commit("state", { uuid: finalUserId, accessToken, refreshToken });
    storage.setItem("accessToken", accessToken);
    storage.setItem("refreshToken", refreshToken);
    storage.setItem("uuid", finalUserId);
    upsertLocalAccount({
      userId: finalUserId,
      accessToken,
      accessExpire,
      refreshToken,
      refreshExpire,
    });
  },
  refreshToken: async ({ commit, dispatch }, refreshToken) => {
    let rs = await Ajax(
      "login/new-refresh-token",
      { refreshToken },
      { auth: false }
    );
    if (rs.code == 1) {
      await dispatch("setCookies", rs.data);
      window.location.reload();
    }
  },
  switchAccount: async ({ dispatch, state }, account) => {
    if (!account || !account.refreshToken) {
      return { code: 0, needLogin: true, msg: "登录已过期，请重新登录" };
    }
    if (String(account.userId) === String(state.uuid)) {
      return { code: 1, same: true };
    }
    const rs = await Ajax(
      "login/new-refresh-token",
      { refreshToken: account.refreshToken },
      { auth: false, skipLogout: true }
    );
    if (rs.code == 1) {
      await dispatch("setCookies", {
        ...rs.data,
        userId:
          (rs.data && (rs.data.userId || rs.data.id)) || account.userId,
      });
      await dispatch("getUserData", true);
      try {
        window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(
          JSON.stringify(rs.data)
        );
      } catch (error) {
        console.log(error);
      }
      return rs;
    }
    return {
      ...(rs || {}),
      code: (rs && rs.code) || 0,
      needLogin: true,
      msg: (rs && rs.msg) || "登录已过期，请重新登录",
    };
  },
  triggerExitId: async ({ commit }, val) => {
    commit("state", { instanceId: val });
  },
  logout: async ({ commit }, action = "push") => {
    if (action != "replace") {
      await Ajax("login/logout-login");
    }
    Cookies.remove("openid");
    for (let key of ["accessToken", "refreshToken"]) {
      Cookies.remove(key);
      commit("state", { [key]: null });
    }
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    storage.removeItem("accessToken");
    storage.removeItem("refreshToken");
    storage.removeItem("uuid");
    sessionStorage.removeItem("active");
    commit("state", { userData: null, uuid: "" });
    if (action == "replace") {
      router.push({ name: "home" });
      myPopup({
        onSuccess: () => {},
      });
    } else {
      router.push({ name: "home" });
    }
    // try {
    //   if (action == "replace") {
    //     // 一键登录
    //     window.webkit.messageHandlers.openPnsLoginWebToNative.postMessage("xx");
    //   } else {
    //     router.push({ name: "home" });
    //     myPopup({
    //       onSuccess: () => {},
    //     });
    //   }
    // } catch (error) {
    //   router.push({ name: "home" });
    // }

    try {
      window.webkit.messageHandlers.userLogoutWebToNative.postMessage("xxxxx");
    } catch (error) {
      console.log(error);
    }
  },
  getUserData: async ({ commit }, cacheClear) => {
    if (cacheClear || !state.userData) {
      const rs = await Ajax("user/get-user-data");
      const userData = rs.data;
      commit("state", { userData });
      if (rs.code == 1 && userData) {
        commit("setUuid", userData.id);
        storage.setItem("uuid", userData.id);
        upsertLocalAccount({
          userId: userData.id,
          nickName: userData.nick_name,
          phone: userData.phone,
          headImg: userData.head_img,
          refreshToken: state.refreshToken,
          accessToken: state.accessToken,
        });
      }
    }
  },
  pushError: ({ commit, dispatch }, error) => {
    state.errorQueue.add(error);
    dispatch("delayError");
  },
  delayError: debounce(({ commit }) => {
    for (let msg of [...state.errorQueue]) {
      if (msg && typeof msg == "string") {
        if (
          storage.getItem("is_standalone") == "true" &&
          msg.includes("Network Error") &&
          location.href.includes("home")
        ) {
          // location.href = "/home";
        } else {
          // Toast(msg)
        }
      } else {
        console.warn(msg);
      }
    }
    state.errorQueue.clear();
  }, 500),
};

const storagePlugin = (store) => {
  store.subscribe(({ type }, { searchHistory }) => {
    if (["addSearchHistory", "deleteHistory", "clearHistory"].includes(type)) {
      storage.setItem(
        localStorageKey,
        JSON.stringify({
          searchHistory,
        })
      );
    }
  });
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [storagePlugin],
});

export default store;
